<template>
  <v-container class="error-page fill-height" tag="section">
    <v-row class="text-center" justify="center">
      <v-col cols="auto">
        <h1 class="title font-weight-black">{{errorId}}</h1>

        <div class="display-3 mb-5 mt-10">{{errorMsg}}</div>

        <v-btn @click.native="tryReload()">Retry</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "PagesError",
  props: {
    errorId: {
      type: String,
      default: "503"
    },
    errorMsg: {
      type: String,
      default: "There was an error"
    }
  },
  methods: {
    tryReload: function() {
      window.location = "/";
    }
  }
};
</script>

<style lang="sass">
  .error-page
    h1
      font-size: 12rem
</style>
